import { salePnl, type ValidatedSale } from '@porttang/core';
import { formatPercent, formatSignedAmount, toneClassFor } from '../../shared/format';

/**
 * กำไรที่จะรับรู้จากการขายครั้งนี้ — ใช้ร่วมกันทั้งปุ่ม "ขาย" และจอสแกนสลิป
 *
 * ตัวเลขมาจาก `salePnl` ใน core ที่นี่แค่แสดง แสดงในสกุลของรายการ ไม่แปลงเป็นบาท
 * เพราะผู้ใช้กำลังเทียบกับตัวเลขในแอปโบรกซึ่งเป็นสกุลเดียวกัน
 */
export function SaleRealizedRow({ sale }: { sale: ValidatedSale }) {
  const { pnl, pnlPct } = salePnl(sale);

  return (
    <div className="mt-3 border-t border-line-soft pt-3">
      <div className="text-xs text-ink-400">กำไรที่รับรู้จากการขายครั้งนี้</div>
      <div className={`mt-0.5 font-mono text-[13px] ${toneClassFor(pnl)}`}>
        {formatSignedAmount(pnl, sale.currency)}
        {pnlPct !== null && ` (${formatPercent(pnlPct)})`}
      </div>
      <p className="mt-0.5 text-[11px] text-ink-600">
        (ราคาขาย − ต้นทุนเฉลี่ย) × จำนวน — เก็บไว้ที่หน้า “ขาย &amp; ปันผล” แม้ขายหมดแล้ว
      </p>
    </div>
  );
}
